import axios from "axios";
import { getAccessToken, login } from "../auth/auth";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.vienna.local";

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

// ✅ Bearer Token automatisch anhängen
api.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Logging + optional: bei 401 neu einloggen (aber NICHT im OIDC Callback!)
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err?.response?.status;
    const suppressErrorLogging = err?.config?.suppressErrorLogging === true;
    const skipAuthRedirect = err?.config?.skipAuthRedirect === true;

    if (!suppressErrorLogging) {
      console.error("[API ERROR]", status, err?.response?.data || err.message);
    }

    // Wenn wir gerade im OIDC Callback/Silent Renew sind, KEIN login triggern
    const path = window.location.pathname;
    const inOidcFlow =
      path.startsWith("/auth/callback") ||
      path.startsWith("/auth/silent-renew");

    if (status === 401 && !inOidcFlow && !skipAuthRedirect) {
      await login();
    }

    return Promise.reject(err);
  }
);
